import gql from 'graphql-tag';

export const uploadCSVMutation = gql`
  mutation uploadCSVMutation($uploadCSVData: UploadCSVData!) {
    uploadCSV(uploadCSVData: $uploadCSVData) {
      fileUrl
    }
  }
`;
